import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["role", "tabIndex", "children", "interactive", "onItemClick", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useMemo, forwardRef } from 'react';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import useEventCallback from '@segment/utils/useEventCallback';
import { MenuListStateProvider } from './MenuListContext';
import * as views from './MenuList.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var BaseMenuList = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var role = _ref.role,
      tabIndex = _ref.tabIndex,
      children = _ref.children,
      interactive = _ref.interactive,
      onItemClick = _ref.onItemClick,
      tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  var onClickHandler = useEventCallback(onItemClick, []);
  var state = useMemo(function () {
    return {
      interactive: interactive,
      onClick: onClickHandler
    };
  }, [interactive, onClickHandler]);
  return _jsx(MenuListStateProvider, {
    value: state,
    children: _jsx(views.MenuList, _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      role: role,
      tabIndex: tabIndex
    }, rest), tokens), {}, {
      children: children
    }))
  });
});
export var MenuList = withDesignTokens(BaseMenuList, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[600]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      backgroundColor: theme.palette.neutrals.white[100]
    };
  }
});